import * as React from 'react';
import { useEffect } from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import { isEmpty } from 'lodash';
import TopBar from '../components/Topbar';
import Layout from '../components/Layout';
import { DWTCContext } from '../utils/context';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import EventsDetails from '../components/EventsDetails';
import { DatePickerProvider } from '../context/DatePickerContext';

export default function Event(props) {
  
  const { data, pageContext } = props;
  const { event } = data.umbraco;
  const { langCode, lang } = pageContext;

  if (isEmpty(event)) return null;
  if (isEmpty(event.settings)) return null;

  const settings = event.settings.items[0].children.items.find(
    (item) => item.contentTypeAlias === 'dwtcSettings',
  );
  
  const translationsFirst = 
    event.settings.items[0].children.items[0].children.items.find(
      (item) => item.contentTypeAlias === 'translations',
    )
      
  const translations = translationsFirst.translations?.map((t) => t.content) || [];

  const values = { langCode, translations };

  const memo = React.useMemo(() => values, [values]);

  const getDir = () => (lang === 'ar' ? 'rtl' : 'ltr');

  useEffect(() => {
    document.body.classList.add('is-event');
    document.body.classList.add('is-article');
    return () => {
      document.body.classList.remove('is-event');
      document.body.classList.remove('is-article');
    };
  }, []);

  return (
    <DWTCContext.Provider value={memo}>
      <DatePickerProvider>
        {/* <Helmet
          bodyAttributes={{
            class: 'is-event is-article',
          }}
        /> */}
        <Layout dir={getDir()}>
          <Seo page={event} lang={langCode} dir={getDir()} type="event" />
          <TopBar
            currentClass=""
            settings={settings}
            currentPage={{
              id: event.id,
              url: event.url,
              udi: `umb://document/${event.id.replace(/-/g, '')}`,
            }}
            lang={langCode}
            dir={getDir()}
          />
          <EventsDetails data={event} dir={getDir()} />
          <Footer settings={settings} lang={langCode} dir={getDir()} />
        </Layout>
      </DatePickerProvider>
    </DWTCContext.Provider>
  );
}

export const query = graphql`
  query ($id: ID!, $lang: String!) {
    umbraco {
      event(id: $id, culture: $lang) {
        settings: ancestors(where: { contentTypeAlias: "dwtcHome" }) {
          items {
            children(where: { contentTypeAlias: "dwtcSettings" }) {
              items {
                ... on Umbraco_DwtcSettings {
                  ...DwtcSettings
                  children(where: { contentTypeAlias: "translations" }) {
                    items {
                      ...Translations
                    }
                  }
                }
              }
            }
          }
        }
        id
        url
        eventLogo {
          url
        }
        eventArabicLogo(culture: $lang) {
          url
        }
        eventOrganiser
        eventSectors
        eventType
        eventVenues
        eventAudiences
        endDate
        location
        startDate
        websiteURL
        pageContent(culture: $lang)
        instagram(culture: $lang)
        linkedIn(culture: $lang)
        twitter(culture: $lang)
        tiktok(culture: $lang)
        youtube(culture: $lang)
        facebook(culture: $lang)
        createDate
        updateDate
        title
        description
        imagesCarousel {
          url
        }
        featuredImage {
          url
        }
        heroImage {
          url
        }
      }
    }
  }
`;
